module.exports = __webpack_public_path__ + "img/TOMAN-DARK.aec84335.svg";